import { Component, OnInit, ViewChild, ElementRef, NgZone} from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';
import {SiteuserService} from '../services/siteuser.service';
import { CheckoutService } from '../services/checkout.service';
import {CartService} from '../services/cart.service';
import { HttpClient} from '@angular/common/http';
import {environment as env} from '../../environments/environment';
import {LanguageService} from '../services/language.service';
import { NgForm } from '@angular/forms';
import { DatePipe, Location } from '@angular/common';
import { OrderonlineServiceService } from '../services/orderonline-service.service';
import { MapsAPILoader} from '@agm/core';


@Component({
  selector: 'app-guest-checkout',
  templateUrl: './guest-checkout.component.html',
  styleUrls: ['./guest-checkout.component.css']
})
export class GuestCheckoutComponent implements OnInit {

  @ViewChild('search') 
  public searchElement: ElementRef;
  @ViewChild('paybtn') paybtn:ElementRef;
  @ViewChild('closebutton') closebutton;
  
  storedCart = [];
  total:any;
  order = [];
  orderItem = [];
  orderOptions = [];
  orderAddons = [];
  isloggedin:boolean;
  uname:string;
  sajid:string;
  userdata:[] = [];
  adrsData:[] = [];
  adressId:number;
  lastOrderId:string;
  baseprice:any;
  livePrice:any;
  addOnprice:any;
  newPrice:any;
  optionPrice:any;
  cpnCode:string;
  discountedAmount:any;
  finalAmount:any;
  cutlery:string;
  isCpnApplied:number;
  cpnAmount:any;
  paymentMethod : string;
  errmsg:string; 
  errmsg_ar:string; 
  isError = true;
  isSuccess = true;
  orderDate :any;
  showscheduleDelivery:boolean;
  schDate:any;
  fromTime:any;
  toTime:any;
  schMsg:string;
  schMsg_ar:string;
  userEmail:string;
  userPhone:any;
  restaurants = [];
  disArray = [];
  isScheduled:number;
  shipChrage:any;
  priceWithShiping:any;
  minDeliveryAmt:any;
  dlvrMsg:string;
  dlvrMsg_ar:string;
  addrerrmsg_ar:string;
  isCutlery:number;
  rewardPoints:number;
  rewardRate:number;
  rewardPrice:any;
  usedPoints:number;
  usedPrice:any;
  remainPoints:number;
  isrewardMsg:boolean;
  netPayable:any;
  isRedeem:boolean;
  loyalty_applied:number;
  loyalty_point_spent:number;
  loyalty_point_amount:any;
  isLoading:boolean;
  isRedeemLoading:boolean;
  isMultipleAdrs:boolean;
  allAdrs:[] = [];
  showShopping:boolean;
  API_URL:string;
  cardAmount:any;
  totalWithShiping:any;
  taxAmt:any;
  maxOrdPercent:number;
  maxAllowedPoints:number;
  isFirstpayment:boolean;
  imgurl:string;
  bnrAr:any[]=[];
  useablePoints:number;
  usedPoints1:number;
  showLang:string;
  shopStatus:number;
  zoneId:number;
  isCodClicked:boolean;
  isCardClicked:boolean;
  pickUp:number;
  branchName:any;
  branchMsg: any;
  
  private geoCoder;
  address:string;
  latitude: number;
  longitude: number;
  zoom: number;
  country:string;
  state:string;
  city:string;
  address_1:string;
  address_2:string;
  apartment:string;
  isMobile: boolean;
  feastDate: any;
  chkIsFeast: boolean;
  feastTime: any;
  orderfeastDate: string;
  isFeaset: any;
  orderfeastTime: any;
  addrerrmsg: string;
  phoneerrmsg: string;
  phoneerrmsg_ar: string;
  addr2errmsg: string;
  addr2errmsg_ar: string;
  deliveryInstruction:string;
  outofZone:boolean;
  
  constructor(private usrObj:SiteuserService, 
    private route:ActivatedRoute,
    private router:Router,
    private CheckService:CheckoutService,
    private http:HttpClient,
    private srvcart:CartService,
    public datepipe: DatePipe,
    private langObj:LanguageService,
    private location: Location,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private bnrObj:OrderonlineServiceService) { 
      this.API_URL =  env.apiurl;
      this.imgurl =  env.imgurl;
      this.langObj.langStr.subscribe((data)=>{
        this.showLang = data;
      });
    }
  
    timings = [];

    ngOnInit(): void {
      this.getLocation()
      this.pickUp=0;
      this.isCpnApplied = 0;
      this.paymentMethod = 'Card';
      this.cpnCode='';
      this.cpnAmount='';
      this.dlvrMsg='';
      this.isScheduled=0;
      this.shipChrage=0;
      this.loyalty_applied=0;
      this.loyalty_point_spent=0;
      this.loyalty_point_amount=0;
      this.isFirstpayment= true;
      this.zoneId = 0;
      this.shopStatus =0;

      let hours, minutes, ampm;
      for (let i = 420; i <= 1320; i += 15){
        hours = Math.floor(i / 60);
          minutes = i % 60;
          if (minutes < 10){
              minutes = '0' + minutes; // adding leading zero
          }
          ampm = hours % 24 < 12 ? 'AM' : 'PM';
          hours = hours % 12;
          if (hours === 0){
              hours = 12;
        }
        this.timings.push(hours + ':' + minutes + ' ' + ampm)
        
      }

      this.showLang = localStorage.getItem("showLang");
      if(this.showLang == null && this.showLang == undefined){
       this.showLang = 'en';
      }
  
      this.bnrObj.orderOnlineBanner('Checkout Page').subscribe((data:any)=>{
        this.bnrAr = data.data[0];
      });
  
      //get shopclosed status
      this.http.get(env.apiurl+'get-shop-status').subscribe(data=>{
        this.shopStatus = data['status'];
      });
  
  
      this.cutlery = this.srvcart.chkCutleryAvailable();
      if(this.cutlery == 'yes'){
        this.isCutlery =1;
      }else{
        this.isCutlery =0;
      }
  
      this.orderDate =  this.datepipe.transform(new Date(), 'yyyy-MM-dd');
      this.sajid = localStorage.getItem('sajid');
      this.http.get(env.apiurl+'get-user-by-id/'+this.sajid).subscribe(data=>{
        this.userdata = data['data'];
      });
  
      //get user addresses
      this.http.get(env.apiurl+'get-addresses-by-uid/'+this.sajid).subscribe(data=>{
        this.allAdrs = data['data'];
        if(this.allAdrs.length > 1){
          this.isMultipleAdrs = true;
          for(var j=0; j < this.allAdrs.length; j++){
            if(this.allAdrs[j]['isDefault']){
              this.adrsData = data['data'][j];
              break;
            }else{
              this.adrsData = data['data'][j];
            }
          }
        }else{
          this.adrsData = data['data'][0];
        }
        
        // //get all restaurants
        // this.http.get(env.apiurl+'get-all-rests').subscribe(data=>{
        //   this.restaurants = data['data'];
        //   this.getAddrsIdInit();
        // });
  
      });
     
      //get reward points
      this.http.get(env.apiurl+'get-current-reward?uid='+this.sajid).subscribe(data=>{
        this.rewardPoints = data['data']['userpoints'];
        if(this.rewardPoints < 1){
          this.isRedeem = true;
        }
      });
  
      //get reward rate
      this.http.get(env.apiurl+'getreward-rate').subscribe(data=>{
        this.rewardRate = data['data']['points_per_sale'];
        this.maxOrdPercent = data['data']['ordr_redeem_percent'];
        this.maxAllowedPoints = data['data']['max_allowed_points'];
      });
  
      this.storedCart = JSON.parse(localStorage.getItem("cartData"));
      this.onCheckout();
      
    }
  
  onChanegAddress(value) {
    if (value == '') {
      this.latitude = undefined;
      this.longitude = undefined;
    }
  }
  

  //as soon comes on the checkout

  async onCheckout(){
    if(this.storedCart.length > 0){
      this.total = 0;
      this.livePrice=0
      let pslug = '';
      for(var i=0; i < this.storedCart.length; i++ ){
        pslug = this.storedCart[i].pslug;
        let response:any = [];
        response = await this.http.get(env.apiurl+'get-prod-by-slug/'+pslug).toPromise();
        let cartAddons = [];
        let cartOptions = [];
        let liveAddonPrice =0;
        let liveOptionPrice =0;
        let liveOptionValueId =0;
        let liveAddonValueId =0;
        this.baseprice = response.data.price;
        this.storedCart[i].basePrice = this.baseprice;

      //calculate live addons price
      if(response.data.padons){
        for(var b =0; b < response.data.padons.length; b++){
            for(var c=0; c < response.data.padons[b].padonvalues.length; c++){
              liveAddonPrice = response.data.padons[b].padonvalues[c].adonPrice;
              liveAddonValueId = response.data.padons[b].padonvalues[c].id;
            }
        } 
      }
      
      //update localstorage addon price with live addons price
      cartAddons = this.storedCart[i].addons;
      if(cartAddons){
        for(var a =0; a < cartAddons.length; a++){
          if(this.storedCart[i].addons[a].valueid == liveAddonValueId){
            this.storedCart[i].addons[a].addonprice = liveAddonPrice;
          }
        }
      }

       //calculate live verients or optoins price
       if(response.data.poptions){
        for(var d =0; d < response.data.poptions.length; d++){
            for(var e=0; e < response.data.poptions[d].poptionvalues.length; e++){
              liveOptionPrice = response.data.poptions[d].poptionvalues[e].ovprice;
              liveOptionValueId = response.data.poptions[d].poptionvalues[e].id;
            }
        } 
      }

      //update localstorage options price with live options price
      cartOptions = this.storedCart[i].varients;
      if(cartOptions){
        for(var f =0; f < cartOptions.length; f++){
          if(this.storedCart[i].varients[f].optvalueid == liveOptionValueId){
            this.storedCart[i].varients[f].ovprice = liveOptionPrice;
          }
        }
      }
      localStorage.setItem("cartData", JSON.stringify(this.storedCart));
      this.productTotal(this.storedCart[i].addons, this.storedCart[i].varients,this.storedCart[i].qty,i);

      //feastdate functionalities
      this.feastDate = this.storedCart[i].isFeastDate;
      if(this.feastDate){
        this.chkIsFeast = true;
        this.isScheduled = 1;
        this.showscheduleDelivery = true;
        this.schDate = this.feastDate;
        this.orderfeastDate = new Date(this.schDate).toISOString().split('T')[0];
        let feastHours = new Date(this.schDate).getHours();
        //console.log("feastHours", feastHours)

        let feastMinutes = new Date(this.schDate).getMinutes();
        let ampm = feastHours % 24 < 12 ? 'AM' : 'PM';
        feastHours = feastHours % 12;
        if (feastHours === 0) {
          feastHours = 12;
        }
      }
      this.feastTime = this.storedCart[i].isFeasTime; 
      if (this.feastTime) {
        this.orderfeastTime = this.feastTime
        this.fromTime = this.feastTime;
        this.toTime = ''; 
      }
      this.isFeaset = this.storedCart[i].isFeast; 
      //create array of orderItem from cart data;
      let orderItemarray = {
        'itemname': this.storedCart[i].pName,
        'itemid': this.storedCart[i].pId,
        'quantity': this.storedCart[i].qty,
        'pRate': this.storedCart[i].basePrice,
        'pComent': this.storedCart[i].pComent,
        'pTotal': this.storedCart[i].totalPrice,
        'isFeast': this.storedCart[i].isFeast,
        'isFeastDate': this.storedCart[i].isFeastDate,
        'orderoptions': this.storedCart[i].varients,
        'orderadons': this.storedCart[i].addons,
        'ingredients': this.storedCart[i].ingradients
        
      }
      this.orderItem.push(orderItemarray);

      this.getFinalAmount(this.total);
      this.totalWithShiping = this.total;

        if (sessionStorage.getItem("sjcpncode") != null) {
          this.isCpnApplied = 1;
          this.cpnCode = sessionStorage.getItem("sjcpncode");
        }
        if (sessionStorage.getItem("sjcartdcnt") != null) {
          this.cpnAmount = sessionStorage.getItem("sjcartdcnt");
        }

         
      }
      
    }
    this.calculateNetPayable(this.total,this.shipChrage,this.cpnAmount,this.usedPrice);
  }

  onPaymentClick(del_inst) {
    
   this.deliveryInstruction = del_inst;
    if(this.paymentMethod == 'COD'){
      this.isCodClicked = true;
    }
  
    if (this.userPhone === undefined) {
      this.isCodClicked = false;
      this.phoneerrmsg = "Enter Your Mobile Number";
      this.phoneerrmsg_ar = "أدخل رقم هاتفك المحمول";
      return
    } else {
      this.phoneerrmsg = ""
    }
      if (this.latitude === undefined ) {
        this.isCodClicked = false;
        this.addrerrmsg = "Look the closest landmark to your address from list";
        this.addrerrmsg_ar = "ابحث عن أقرب معلم إلى عنوانك من القائمة";
        return
      } else {
        this.addrerrmsg = ""
      }
      if (this.address_2 === undefined || this.address_2 == '') {
        this.isCodClicked = false;
        this.addr2errmsg = "Enter your full address manually here.";
        this.addr2errmsg_ar = "أدخل عنوانك الكامل يدويًا هنا";
        return
      } else {
        this.addr2errmsg = ""
      }
    if (this.apartment === undefined) {
      this.isCodClicked = false;
      this.errmsg = "Enter your villa or apartment number.";
      this.errmsg_ar = "أدخل رقم الفيلا أو الشقة الخاصة بك"
      return
    } else {
      this.errmsg = ""
    }

      this.CheckService.checkuserExists(this.userPhone).subscribe((res) => {
     
        if (res['success'] === false) {
        
          const userData = {
            username: this.uname,
            useremail: this.userEmail,
            userphone: this.userPhone,
            userpass: "Sajway@321"
          }
          this.usrObj.register(userData).subscribe((res) => {
            if (res['success'] === true) {
              this.sajid = res['data'].id
              // call add address api and get address id
              const addrData = {
                userid: this.sajid,
                userName: this.uname,
                phoneNumber: this.userPhone,
                address_one: this.address_1,
                address_two: this.address_2,
                apartment: this.apartment,
                city: this.city,
                state: this.state,
                country: this.country,
                lat: this.latitude,
                long: this.longitude,
                usertype: "guest"
              };
              this.usrObj.addUserAddress(addrData).subscribe(result => {
                this.adressId = result['rdata'].id;
                this.makePayment();
              })
            }
          })
        }
        if (res['success'] === true) {
          this.sajid = res['data'].id;
          // call add address api and get address id
          const addrData = {
            userid: this.sajid,
            userName: this.uname,
            phoneNumber: this.userPhone,
            address_one: this.address_1,
            address_two: this.address_2,
            apartment: this.apartment,
            city: this.city,
            state: this.state,
            country: this.country,
            lat: this.latitude,
            long: this.longitude,
            usertype: "guest"
          };
          this.usrObj.addUserAddress(addrData).subscribe(result => {
            this.adressId = result['rdata'].id
            this.makePayment()
          })
        }
      })
    }
  
    makePayment(){ 
      
      if(this.paymentMethod == 'COD'){
        this.isCodClicked = true;
      }
      
      if(this.pickUp){
        if(this.branchName == undefined || this.branchName == ''){
          this.branchMsg = "Select pick up branch";
          //this.schMsg_ar = "حدد تاريخ التسليم";
          this.isCodClicked = false;
          return false;
        }else{
          this.branchMsg = '';
        }
    }


    
      if(this.showscheduleDelivery){ 
        if(this.schDate == undefined || this.schDate == '' ){
          this.schMsg = "Select delivery date";
          this.schMsg_ar = "حدد تاريخ التسليم";
          this.isCodClicked = false;
          return false;
        }else{
          this.schMsg ='';
        }
    
        if(this.fromTime == undefined || this.fromTime == ''){
          this.schMsg = "Select time";
          this.schMsg_ar = "اختر من وقت";
          return false;
        }
      }
  
  
      let order ={
        "siteuser_id" : this.sajid,
        "payment_type": this.paymentMethod,
        "order_from": "web",
        "cart_total" : this.total,
        "ordrTax": "0",
        "finalTotal" : this.finalAmount,
        "netPaid": this.netPayable,
        "coupon_apply" : this.isCpnApplied,
        "coupon_code" : this.cpnCode,
        "coupon_amount" : this.cpnAmount,
        "loyalty_applied" : this.loyalty_applied, 
        "loyalty_points_spent" : this.loyalty_point_spent,
        "loyalty_points_amount" : this.loyalty_point_amount,
        "isScheduled":this.isScheduled,
        "isCutlery": this.isCutlery,
        "sdate":this.schDate,
        "time_from":this.fromTime,
        "time_to":this.toTime,
        "shiping_chrg":this.shipChrage,
        "useraddress_id":this.adressId,
        "OrderItems": this.orderItem,
        "zone_id": this.zoneId,
        "usertype": "guest",
        "deliver_instruction": this.deliveryInstruction,
        "pickup": this.pickUp,
        "branch_name": this.branchName
      }
      
      if(this.adressId){
        var newtotal = parseFloat(this.total) + parseFloat(this.shipChrage);
        var newmindeliveryAmt = parseFloat(this.minDeliveryAmt);
       
        if(this.pickUp == 0){
          if(newtotal < newmindeliveryAmt){
            this.showShopping = true;
            this.dlvrMsg = 'Minimum order amount should be AED '+ this.minDeliveryAmt+' to deliver this address';
            this.dlvrMsg_ar = 'يجب أن يكون الحد الأدنى لمبلغ الطلب AED '+ this.minDeliveryAmt+' لتسليم هذا العنوان';
            this.isCodClicked = false;
            return false;
          }else{
            this.dlvrMsg='';
          }
        }else{
          this.dlvrMsg='';
        }
        
        this.isLoading = true;
        
        if(this.isFirstpayment){
          this.isCodClicked = true;
          
           this.CheckService.orderPlace(order).subscribe((data:any)=>{
            this.isLoading = false;
            this.lastOrderId = data['data'];
            this.isFirstpayment = false;
            let festdatetime = '';
            if(this.orderfeastDate || this.orderfeastDate != ''){
              let formtdate  = this.usrObj.dateToDMY(this.orderfeastDate);
              festdatetime = formtdate + ' ' + this.orderfeastTime;
            }
            let orderDetails = {
              'order_id': this.lastOrderId,
              'order_amt': this.finalAmount,
              'netPaid': this.netPayable,
              'order_date':this.orderDate,
              'payment_method': this.paymentMethod,
              'feastdata':festdatetime
            }
            localStorage.setItem('order_details',JSON.stringify(orderDetails));
  
            if(this.paymentMethod == 'Card'){
              this.paybtn.nativeElement.click();
            }else if(this.paymentMethod == 'COD'){
              this.router.navigate(['/thank-you']);
              return false;
            }
            
          });
        
       }
  
      }else{
        this.dlvrMsg = "Choose your address";
        this.dlvrMsg_ar = "اختر عنوانك";
        this.isCodClicked = false;
      }
      
    }
  
  
  
    getCouponDetails(){ 
      if (localStorage.getItem("sjcartdcnt") != null) {
        this.discountedAmount = parseFloat(localStorage.getItem("sjcartdcnt")).toFixed(2);
      }
      
    }
  
  
    getFinalAmount(total:number){
      this.finalAmount = total;
      if (sessionStorage.getItem("sjcartdcnt") != null && sessionStorage.getItem("sjcpncode") != null) {
        this.cpnCode = sessionStorage.getItem("sjcpncode");
        this.discountedAmount = parseFloat(sessionStorage.getItem("sjcartdcnt")).toFixed(2);
        this.finalAmount = total-this.discountedAmount;
      }
      this.finalAmount = parseFloat(this.finalAmount).toFixed(2);
    }
  
    getPaymentMethod(paymentMedthod){
        this.paymentMethod = paymentMedthod;
    }
  
  
    getAddrsId(e){
        this.disArray = [];
        var userLat = e.getAttribute('lat');
        var userLong = e.getAttribute('long');
        for(var i=0; i < this.restaurants.length; i++){
          var lat1 = this.restaurants[i].lat;
          var long1 = this.restaurants[i].long;
          var disTancce = this.calculateDistance(lat1, long1, userLat,userLong);
          this.disArray.push(disTancce);
        }
        
        var smallestDis = Math.min.apply( Math, this.disArray );
        this.shipChrage = this.calculateShipping(smallestDis);
        if(this.shipChrage == undefined){
          this.shipChrage = 0;
        }
        this.adressId =e.value;
  
        console.log('dist'+smallestDis);
        this.adrsData["userName"] = e.getAttribute('uname');
        this.adrsData["apartment"] = e.getAttribute('apartment');
        this.adrsData["address_one"] = e.getAttribute('adr-1');
        this.adrsData["address_two"] = e.getAttribute('adr-2');
        this.adrsData["area"] = e.getAttribute('area');
        this.adrsData["city"] = e.getAttribute('city');
        this.adrsData["state"] = e.getAttribute('state');
        this.adrsData["country"] = e.getAttribute('country');
        this.closebutton.nativeElement.click();
    }
  
    getAddrsIdInit(userlat, userlng){

      this.disArray = [];
      var userLat = userlat;
      var userLong = userlng;
      for(var i=0; i < this.restaurants.length; i++){
        var lat1 = this.restaurants[i].lat;
        var long1 = this.restaurants[i].long;
        var disTancce = this.calculateDistance(lat1, long1, userLat,userLong);
        this.disArray.push(disTancce);
      }
      
      var smallestDis = Math.min.apply( Math, this.disArray );
  
      console.log('dist'+smallestDis); 
  
      this.shipChrage = this.calculateShipping(smallestDis);
      // this.adressId = this.adrsData['id'];
      if(this.shipChrage == undefined){
        this.shipChrage = 0;
      }
      if(this.pickUp == 1){
        this.shipChrage = 0;
      }
      
    }
  
  
  
    ondeleteaddr(addrid:number){
      this.http.post(env.apiurl+'delete-delivery-address', {
        userid:this.usrObj.getLoggedinId(),
        addressid:addrid,
      }).subscribe(rawData=>{
  
        if (rawData['success'] == true){
          location.reload();
        }else{
          this.isError = true;
          this.isSuccess = false;
          this.errmsg = rawData['data']; 
        }
      });
  
    }
  
    onEditAddressClick(adrsid){
      //console.log(adrsid);
    }
  
    scheduleDelivery(e){
      if(e.checked){
          this.isScheduled=1;
          this.showscheduleDelivery = true;
      }else{
          this.isScheduled=0;
          this.showscheduleDelivery = false;
      }
    }
  
    getDate(val){
        this.schDate = val;
    }
  
    getfromTime(val){
        this.fromTime = val;
    }
  
    gettoTime(val){
        this.toTime = val;
    }
  
    calculateDistance(lat1, lon1, lat2, lon2) {
      if ((lat1 == lat2) && (lon1 == lon2)) {
        return 0;
      }else {
        var radlat1 = Math.PI * lat1/180;
        var radlat2 = Math.PI * lat2/180;
        var theta = lon1-lon2;
        var radtheta = Math.PI * theta/180;
        var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
        if (dist > 1) {
          dist = 1;
        }
        dist = Math.acos(dist);
        dist = dist * 180/Math.PI;
        dist = dist * 60 * 1.1515;
        dist = dist * 1.609344;
        return dist;
      }
    }
  
    calculateShipping(dist){
      this.http.get(env.apiurl+'get-all-zones').subscribe(data=>{
        var zoneData = data['data'];
        this.outofZone = true;
        for(var j=0; j<zoneData.length; j++){
          if( dist >= zoneData[j].min_kilometer && dist <= zoneData[j].max_kilometer){
            this.outofZone = false;
            this.shipChrage = zoneData[j].shipping_charge;
            this.zoneId = zoneData[j].id
            this.minDeliveryAmt = zoneData[j].min_order_amt;
            this.totalWithShiping = (parseFloat(this.total) + parseFloat(this.shipChrage)).toFixed(2);
            this.calculateNetPayable(this.total,this.shipChrage,this.cpnAmount,this.usedPrice);
            if(this.pickUp == 1){
              this.shipChrage=0;
            }
            return this.shipChrage;
          }
        }
        
  
      });
    }
  
  redeemReward(){
      if(this.isCpnApplied){
        this.isrewardMsg=true;
        return false;
      }else{
        this.isrewardMsg=false
      }
  
      this.rewardPrice = this.rewardPoints / this.rewardRate;
      var maxRedeemAbleAmt = (this.finalAmount * this.maxOrdPercent)/100;
  
      this.useablePoints = maxRedeemAbleAmt * this.rewardRate;
      
  
      if(this.useablePoints > this.maxAllowedPoints){
        this.useablePoints = this.maxAllowedPoints;
      }
      
    
    
      this.useablePoints = Number(this.useablePoints);
      this.rewardPoints = Number(this.rewardPoints);
  
    
      if(this.useablePoints > this.rewardPoints){
        this.usedPoints = this.rewardPoints;
        this.rewardPoints = 0;
        this.usedPrice = (this.usedPoints / this.rewardRate).toFixed(2);
      }else{
        this.usedPoints = this.useablePoints;
        var RewardPointsWithtwo = (this.rewardPoints - this.usedPoints).toFixed(2);
        //this.rewardPoints = Number(RewardPointsWithtwo);
        this.rewardPoints = Number(this.rewardPoints - this.usedPoints);
        this.rewardPoints = Math.round((this.rewardPoints + Number.EPSILON) * 100) / 100
        this.usedPrice = (this.usedPoints / this.rewardRate).toFixed(2);
      }
      
  
      this.isRedeem = true;
      this.loyalty_applied=1;
      this.loyalty_point_spent=this.usedPoints;
      this.loyalty_point_amount=this.usedPrice;
      
      this.calculateNetPayable(this.total,this.shipChrage,this.cpnAmount,this.usedPrice);
  }
  
  removeRewardPoints(){
    this.isRedeemLoading = true;
    this.isRedeem = false;
    this.loyalty_applied=0;
    this.loyalty_point_spent=0;
    this.loyalty_point_amount=0;
    this.usedPrice =0;
  
    this.http.get(env.apiurl+'get-current-reward?uid='+this.sajid).subscribe(data=>{
      this.rewardPoints = data['data']['userpoints'];
      this.isRedeemLoading = false;
    });
  
    this.calculateNetPayable(this.total,this.shipChrage,this.cpnAmount,this.usedPrice);
  }
  
  
  removeCpn(){
    sessionStorage.removeItem("sjcpncode");
    sessionStorage.removeItem("sjcartdcnt");
    this.cpnCode='';
    this.isCpnApplied=0;
    this.cpnAmount =0
    this.getFinalAmount(this.total);
    this.calculateNetPayable(this.total,this.shipChrage,this.cpnAmount,this.usedPrice);
  }
  
  calculateNetPayable(totalAmt,shippingAmt,couponAmt,rewardAmt){
    let shipping:any = 0;
    let coupon:any = 0;
    let reward:any = 0;
    
    if(shippingAmt != undefined && shippingAmt !=''){
      shipping = shippingAmt;
    }
  
    if(couponAmt != undefined && couponAmt !=''){
      coupon = couponAmt;
    }
  
    if(rewardAmt != undefined && rewardAmt !=''){
      reward = rewardAmt;
    }
    this.netPayable = (parseFloat(totalAmt) - parseFloat(coupon) - parseFloat(reward) + parseFloat(shipping)).toFixed(2);
    this.cardAmount = parseFloat(this.netPayable);
    var newval = (this.netPayable * 5) / 100;
    this.taxAmt = newval.toFixed(2);
    //this.taxAmt = (this.netPayable * 5) / 100;
  }
  
  
  goBackPage(){
    this.location.back();
  }

  pickUPstore(e){
    if(e.checked){
      this.pickUp = 1;
      this.shipChrage=0;
      this.adressId = 1;
      this.outofZone = false;
      this.totalWithShiping = (parseFloat(this.total) + parseFloat(this.shipChrage)).toFixed(2);
      this.calculateNetPayable(this.total,this.shipChrage,this.cpnAmount,this.usedPrice);
    }else{
      window.location.reload();
    }
    
  }

  getBranchName(branch){
    this.branchName = branch;
  }


  

  getLocation() {
    this.mapsAPILoader.load().then(() => { 
  
      if ('geolocation' in navigator) {
        navigator.geolocation.getCurrentPosition((position) => {
          // this.latitude = position.coords.latitude;
          // this.longitude = position.coords.longitude;
        });
      }
      this.zoom = 8;
      this.geoCoder = new google.maps.Geocoder;
      let autocomplete = new google.maps.places.Autocomplete(this.searchElement.nativeElement);
      // autocomplete.setFields(
      //   ['address_components', 'geometry', 'icon', 'name']);
      autocomplete.setComponentRestrictions({'country': ['are']});
      autocomplete.addListener("place_changed", () => {
      this.ngZone.run(() => {
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }
  
          this.latitude = place.geometry.location.lat();
          this.longitude = place.geometry.location.lng();
          this.zoom = 12;
          this.address_2='';
          this.address_1=place.name;
         
          if(this.pickUp){
            this.shipChrage=0;
            this.adressId = 1;
            this.outofZone = false;
            this.totalWithShiping = (parseFloat(this.total) + parseFloat(this.shipChrage)).toFixed(2);
            this.calculateNetPayable(this.total,this.shipChrage,this.cpnAmount,this.usedPrice);
          }else{
             //get all restaurants
            this.http.get(env.apiurl+'get-all-rests').subscribe(data=>{
              this.restaurants = data['data'];
              this.getAddrsIdInit(this.latitude, this.longitude);
            });

          }
          


        
       
          
          for (var i = 0; i < place.address_components.length; i++) {
                  
            var component = place.address_components[i];
            if(component.types.includes('street_number')) {
                this.address_1 = this.address_1 + ', ' + component.long_name;
            }
            else if(component.types.includes('route')) {
              if(this.address_2 != undefined && this.address_2 != '' ){
                // this.address_2 = this.address_2 + ','+ component.long_name;
              }else{
                // this.address_2 = component.long_name;
              }
              this.address_1 = this.address_1 + ', ' + component.long_name;

            }
            else if(component.types.includes('sublocality')) {
              if(this.address_2 != undefined && this.address_2 != '' ){
                // this.address_2 = this.address_2 + ','+ component.long_name;
              }else{
                // this.address_2 = component.long_name;
              }
              this.address_1 = this.address_1 + ', ' + component.long_name;
                 
            }
            else if(component.types.includes('locality')) {
                  this.city = component.long_name;
            }
            else if (component.types.includes('administrative_area_level_1')) {
                  this.state = component.long_name;
            }
            else if (component.types.includes('country')) {
                  this.country = component.long_name;
            }
          }
        });
      });
    });
  }

  productTotal(addOn, option, qty, k){
    console.log('step-5');
    if(addOn != ''){
      this.addOnprice = 0;
      for(var i=0; i < addOn.length; i++){
       this.addOnprice = (parseFloat(this.addOnprice) + parseFloat(addOn[i]['addonprice'])).toFixed(2);
      }
    }else{
      this.addOnprice = 0;
    }
  
    if(option != ''){
      this.optionPrice = 0;
      for(var j=0; j < option.length; j++){
       if(option[j]['ovqty'] == undefined){
          option[j]['ovqty'] = 0;
       }
       
       this.optionPrice = (parseFloat(this.optionPrice) + (parseFloat(option[j]['ovprice']) * parseFloat(option[j]['ovqty']))).toFixed(2);
      }
    }else{
      this.optionPrice = 0;
    }
    //console.log(this.addOnprice+'addOnprice'); 
    this.newPrice = (parseFloat(this.baseprice) + parseFloat(this.addOnprice) + parseFloat(this.optionPrice)).toFixed(2);
    let priceWithAddon = this.newPrice;
    let eachProdTotalPrice = (this.newPrice * qty).toFixed(2);
    this.total = (parseFloat(this.total) + (this.newPrice * qty)).toFixed(2);
    this.storedCart[k].totalPrice = eachProdTotalPrice;
    this.storedCart[k].priceWithaddon = priceWithAddon;
    localStorage.setItem("cartData", JSON.stringify(this.storedCart));  
  }

}